import { apiClient } from '../Auth/apiClient';
import IResponseBaseTDto from '../Interfaces/IResponseBaseTDto';
import ISearchBaseDto from '../Interfaces/ISearchBaseDto';
import IPageResultDto from '../Interfaces/IPageResultDto';
import ILocationBasicDto from '../Interfaces/ILocationBasicDto';
import IResponseBaseDto from '../Interfaces/IResponseBaseDto';
import ILocationDetailsDto, { IUpdateLocationDto } from '../Interfaces/ILocationDetailsDto';
import { IDevicesBasicDto } from '../Interfaces/IDeviceDtos';
import { IGoalBasicDto } from '../Interfaces/IGoalDtos';
import { IBaseRuleItemDto } from '../Interfaces/IRuleDtos';

//const [locations, setLocations]=useState<ILocationDetailsDto[]>([LocationListItem]);

const LocationsServiceAPI = {
	GetPage: async (data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<ILocationBasicDto>>> => {
		const response = await apiClient.post(`locations`, data);
		return response.data;
	},
	GetOne: async (id: string): Promise<IResponseBaseTDto<ILocationDetailsDto>> => {
		const response = await apiClient.post(`location`, { CPLocationId: id });
		return response.data;
		//  return {
		//   data:LocationListItem,
		//   success: true,
		//   errors: [],
		// };
	},
	Delete: async (id: string): Promise<IResponseBaseDto> => {
		const response = await apiClient.delete(`locations/${id}`);
		return response.data;
	},
	Update: async (data: IUpdateLocationDto): Promise<number> => {
		const response = await apiClient.post(`location/edit`, data);
		return response.data;
	},
	Add: async (data: ILocationDetailsDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.post('locations', data);
		return response.data;
	},
	GetLocationDevices: async (id: string, data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<IDevicesBasicDto>>> => {
		const response = await apiClient.post(`location/locationDevices`, { ...data, locationId: id });
		return response.data;
	},
	GetLocationGoals: async (id: string, data: ISearchBaseDto): Promise<IResponseBaseTDto<IGoalBasicDto[]>> => {
		const response = await apiClient.post(`location/locationGoals`, { ...data, locationId: id });
		return response.data;
	},
	GetLocationGoalsToConnect: async (id: string, data: ISearchBaseDto): Promise<IResponseBaseTDto<IGoalBasicDto[]>> => {
		const response = await apiClient.post(`location/getAddLocationGoal`, { ...data, locationId: id });
		return response.data;
	},
	ConnectGoalToLocation: async (locationId: string, deviceId: string): Promise<number> => {
		const response = await apiClient.post('location/addLocationGoal', { locationId, deviceId });
		return response.data;
	},
	DisconnectGoalFromLocation: async (locationId: string, deviceId: string): Promise<number> => {
		const response = await apiClient.post('location/deleteLocationGoal', { locationId, deviceId });
		return response.data;
	},
	GetLocationRules: async (id: string, data: ISearchBaseDto): Promise<IResponseBaseTDto<IBaseRuleItemDto[]>> => {
		const response = await apiClient.post(`location/rules`, { ...data, locationId: id });
		return response.data;
	},
	DisconnectRuleFromLocation: async (locationId: string, ruleId: number): Promise<number> => {
		const response = await apiClient.post('location/rule/remove', { locationId, ruleId });
		return response.data;
	},
	GetLocationRulesToConnect: async (id: string, data: ISearchBaseDto): Promise<IResponseBaseTDto<IGoalBasicDto[]>> => {
		const response = await apiClient.post('location/rules/available', { ...data, locationId: id });
		return response.data;
	},
	ConnectRuleToLocation: async (locationId: string, ruleId: number): Promise<number> => {
		const response = await apiClient.post('location/rule/create', { locationId, ruleId });
		return response.data;
	},
	GetVoucherDefinitions: async (
		locationId: string,
		data: ISearchBaseDto
	): Promise<IResponseBaseTDto<IPageResultDto<ILocationBasicDto>>> => {
		const response = await apiClient.post(`location/voucherdefinitions`, { ...data, locationId });
		return response.data;
	},
};

export default LocationsServiceAPI;
